import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-star",
  "use": "icon-icon-star-usage",
  "viewBox": "0 0 12 11.413",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 11.413\" id=\"icon-icon-star\">\n  <path id=\"icon-icon-star_Path_1337\" data-name=\"Path 1337\" d=\"M10.166,9.686,6,10.261l3.032,2.914-.74,4.139L12,15.332l3.708,1.983-.74-4.139L18,10.261l-4.166-.575L12,5.9,10.166,9.686\" transform=\"translate(-6 -5.902)\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol